module.exports = __webpack_public_path__ + "static/media/ticket-garantia.03393733.svg";